import { I18nContext } from "./i18n-context";
export const I18nConsumer = I18nContext.Consumer;